import React, { useContext, useEffect, useState } from 'react';
import { Button } from '../Button/Button';
import { cn } from '../cn';
import { AccordionStateContext } from './Accordion';
import { v4 as uuidv4 } from 'uuid';
import { Typography } from '../Typography/Typography';
import { IconChevronDown } from '../Icons';

export type AccordionItemProps = React.PropsWithChildren<{
  heading: string,
  className?: string,
  buttonClassName?: string,
  arrowClassName?: string,
  defaultActive?: boolean,
  id?: string;
}>;

export const AccordionItem = (props: AccordionItemProps): JSX.Element => {
  const accordionState = useContext(AccordionStateContext);
  const [isActive, setIsActive] = useState<boolean>(false);
  const [id, setId] = useState<string>(props.id || '');

  const handleClick = (): void => {
    if(accordionState.showOne == false) {
      setIsActive((prev) => !prev);
    } else {
      if(accordionState.currentActiveId == id) {
        accordionState.setCurrentActiveId(null);
      } else {
        accordionState.setCurrentActiveId(id);
      }
    }
  };

  if(accordionState.showOne == true) {
    if(id == accordionState.currentActiveId && isActive == false) {
      setIsActive(true);
    } else if(id != accordionState.currentActiveId && isActive == true) {
      setIsActive(false);
    }
  }

  useEffect(() => {
    if(id == '') {
      const generatedId = uuidv4();
      setId(generatedId);
      if(props.defaultActive) {
        accordionState.setCurrentActiveId(generatedId);
      }
    }
    else if(props.defaultActive) {
      accordionState.setCurrentActiveId(id);
    }
  }, []);

  return (
    <div className={cn('flex flex-col gap-2 items-stretch', props.className)}>
      <Button
        unstyled
        className={cn(
          'text-left flex flex-1 flex-row justify-between font-bold gap-2 items-center text-text-light hover:text-text active:text-text transition-colors font-expressive-heading text-[26px] leading-9',
          props.buttonClassName
        )}
        onPress = {() => {
          handleClick();
        }}
      >
        {props.heading}
        <IconChevronDown
          className = {cn(
            isActive && 'rotate-180',
            'transform transition-all duration-300 min-h-6 min-w-6',
            props.arrowClassName
          )}
        />
      </Button>
      <Typography className = {`${isActive ? '' : 'hidden'}`}>
        {props.children}
      </Typography>
    </div>
  );
};
